var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380.312 380.312",
    style: {
      enableBackground: "new 0 0 380.312 380.312"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1083_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1084_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#00969B"
    },
    d: "M92.519,330.689h57.637v36.849c0,1.976-2.405,3.316-4.589,2.559l-22.958-7.966 c-0.814-0.283-1.73-0.283-2.544,0l-22.957,7.966c-2.184,0.758-4.589-0.583-4.589-2.559 C92.519,367.538,92.519,330.689,92.519,330.689z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1085_",
    style: {
      fill: "#1F2C47"
    },
    d: "M146.842,380.312c-1.554,0-3.085-0.258-4.553-0.767l-20.952-7.271l-20.951,7.27 c-1.469,0.509-3,0.768-4.553,0.768c-7.342,0-13.314-5.73-13.314-12.773V320.69h77.637v46.849 C160.156,374.581,154.183,380.311,146.842,380.312z M121.337,351.918c1.558,0,3.089,0.257,4.552,0.765l14.267,4.951v-16.945 h-37.637v16.945l14.268-4.951C118.249,352.176,119.78,351.918,121.337,351.918z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1088_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1089_",
    style: {
      fill: "#1F2C47"
    },
    d: "M298.156,340h-203c-24.813,0-45-20.187-45-45V45c0-24.813,20.187-45,45-45h203 c17.645,0,32,14.355,32,32v276C330.156,325.645,315.8,340,298.156,340z M95.156,20c-13.785,0-25,11.215-25,25v250 c0,13.785,11.215,25,25,25h203c6.617,0,12-5.383,12-12V32c0-6.617-5.383-12-12-12H95.156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1092_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    style: {
      fill: "#00969B"
    },
    d: "M255.563,160H124.748c-6.852,0-12.408-5.555-12.408-12.408V91.408 c0-6.852,5.555-12.408,12.408-12.408h130.815c6.852,0,12.408,5.555,12.408,12.408v56.185C267.971,154.445,262.416,160,255.563,160 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1093_",
    style: {
      fill: "#1F2C47"
    },
    d: "M255.563,170H124.749c-12.355,0-22.408-10.052-22.408-22.407V91.408 C102.34,79.052,112.393,69,124.749,69h130.814c12.355,0,22.408,10.052,22.408,22.408v56.185 C277.971,159.948,267.918,170,255.563,170z M124.749,89c-1.328,0-2.408,1.08-2.408,2.408v56.185c0,1.327,1.08,2.407,2.408,2.407 h130.814c1.328,0,2.408-1.08,2.408-2.407V91.408c0-1.328-1.08-2.408-2.408-2.408H124.749z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1096_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1097_",
    style: {
      fill: "#1F2C47"
    },
    d: "M228.931,284.667H151.38c-10.119,0-18.352-8.233-18.352-18.352v-24.296h20v22.648 h74.254v-21h-55.127v-20h56.775c10.119,0,18.352,8.232,18.352,18.352v24.296C247.283,276.434,239.05,284.667,228.931,284.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c35abe0233633d4604a1bf4001053138.svg";
export { ForwardRef as ReactComponent };